import React, { useState } from 'react';
import { X, Sparkles, Layers, Maximize2, Calendar, Users, Zap, MessageSquare, Box, Package, TrendingUp, BadgePercent, Search } from 'lucide-react';

// Uygulamanın güncel changelog sürümü — TEK KAYNAK.
// localStorage 'lastSeenChangelogVersion' bu değerle karşılaştırılır; değiştiğinde
// (yeni sürüm) changelog "bir daha gösterme" seçilmiş olsa bile yeniden açılır.
export const CURRENT_CHANGELOG_VERSION = '2.0.2';

const ChangelogModal = ({ isOpen, onClose, onDontShowAgain }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(null);
  
  if (!isOpen) return null;

  // Versiyon geçmişi — en yeni en üstte
  const versions = [
    {
      version: CURRENT_CHANGELOG_VERSION,
      releaseDate: "23 Temmuz 2026",
      features: [
        {
          icon: Search,
          color: "blue",
          title: "İşlemler Aramasında Türkçe Karakter Desteği",
          description: [
            "İşlemler sayfasındaki arama artık büyük/küçük harf ve Türkçe karaktere duyarsız",
            "\"İpek Kirpik\" gibi kayıtlar i, I, ı veya İ ile arandığında da bulunuyor",
            "Aksansız yazımda da eşleşme sağlanıyor",
          ],
        },
        {
          icon: Calendar,
          color: "cyan",
          title: "Randevudan Adisyon Oluşturmada Düzeltme",
          description: [
            "Randevuyu tamamlayıp adisyon oluştururken önceki adisyonun takip (tracking) bilgilerinin gelmesi sorunu giderildi",
            "Adisyon penceresi artık yalnızca ilgili randevunun hizmetleriyle açılıyor",
          ],
        },
      ],
    },
    {
      version: "2.0.1",
      releaseDate: "23 Temmuz 2026",
      features: [
        {
          icon: Users,
          color: "blue",
          title: "Müşteri Aramasında Türkçe Karakter Desteği",
          description: [
            "Arama artık büyük/küçük harf ve Türkçe karaktere duyarsız çalışıyor",
            "\"Irmak\" gibi kayıtlar büyük I, küçük ı, i veya İ ile arandığında da bulunuyor",
            "Aksansız yazımda da eşleşme: \"gokhan\" → \"Gökhan\", \"sule\" → \"Şule\"",
            "İsim, soyisim, telefon ve e-posta üzerinde çok kelimeli arama iyileştirildi",
          ],
        },
        {
          icon: Calendar,
          color: "cyan",
          title: "Randevu Tamamlamada İyileştirmeler",
          description: [
            "Onay penceresine \"Vazgeç\" (X) butonu eklendi — vazgeçtiğinizde randevunun durumu değişmez",
            "\"Adisyon oluştur\" seçilip adisyon kaydedilmezse randevu otomatik olarak eski durumuna döner",
            "Çift tıklama koruması: tamamlama sırasında butonlar kilitlenir",
          ],
        },
      ],
    },
    {
      version: "2.0.0",
      releaseDate: "3 Haziran 2026",
      features: [
        {
          icon: Box,
          color: "orange",
          title: "Stok Yönetimi",
          description: [
            "Ürün stoklarını gerçek zamanlı takip edin",
            "Adisyon kaydında ilgili ürünlerin stoğu otomatik olarak düşer",
            "Düşük stok uyarıları ile ürün eksikliği yaşamayın",
            "Stok giriş, çıkış ve düzeltme hareketleri kayıt altında",
          ],
          image: "/services-page-stock-feature.png",
        },
        {
          icon: Package,
          color: "cyan",
          title: "Paket & Seans Takibi",
          description: [
            "Çok seanslı paket tanımları oluşturun ve müşterilere satın",
            "Müşteri bazında kalan seans sayısı otomatik güncellenir",
            "Adisyon eklerken paket seansı kullanımı tek tıkla",
          ],
          image: "/customers-page-package-sessions.png",
        },
        {
          icon: TrendingUp,
          color: "green",
          title: "Prim & Performans",
          description: [
            "Hizmet bazlı özel prim oranları tanımlayın",
            "Her adisyon kaydında çalışan primleri otomatik hesaplanır",
            "Aylık prim raporları ile ekip performansını yakından takip edin",
          ],
          image: "/comissions-page-feaute.png",
        },
      ],
    },
    {
      version: "1.5.0",
      releaseDate: "6 Mayıs 2026",
      features: [
        {
          icon: MessageSquare,
          color: "orange",
          title: "Adisyon Not / Açıklama",
          description: [
            "Adisyon oluştururken veya düzenlerken not/açıklama ekleyebilirsiniz",
            "Eklenen notlar adisyon kartında görüntülenir; not eklenmemişse \"Açıklama yok\" gösterilir",
            "Randevu tamamlanıp adisyona dönüştürüldüğünde randevu notları otomatik olarak adisyon not alanına aktarılır",
          ],
          image: "/bill-note-feature.png",
        },
      ],
    },
    {
      version: "1.4.0",
      releaseDate: "22 Nisan 2026",
      features: [
        {
          icon: Sparkles,
          color: "blue",
          title: "Sadakat Puanı Sistemi",
          description: [
            "Müşterilerinize her adisyon için otomatik puan kazandırın",
            "Birikmiş puanları indirim olarak kullanma (eski puanlar öncelikli)",
            "Bronze, Silver, Gold ve özelleştirilebilir seviye kademeleri",
            "Seviyeye özel kazanım çarpanları (örn: Gold seviye %50 bonus puan)",
          ],
          image: "/loyalty-new-feature-3.png",
        },
        {
          icon: Sparkles,
          color: "blue",
          title: "Sadakat Puanı Sistemi",
          description: [
            "Bronze, Silver, Gold ve özelleştirilebilir seviye kademeleri",
            "Seviyeye özel kazanım çarpanları (örn: Gold seviye %50 bonus puan)",
            "Otomatik puan süre takibi ve eski puanların önceliklendirilmesi",
          ],
          image: "/loyalty-new-feature-1.png",
        },
        {
          icon: Sparkles,
          color: "blue",
          title: "Sadakat Puanı Sistemi",
          description: [
            "Geçmiş adisyonlardan toplu puan üretme (backfill) imkanı",
            "Ayarlar > Sadakat Ayarları sayfasından tüm oran, seviye ve süre özelleştirmesi"
          ],
          image: "/loyalty-new-feature-2.png",
        },
        {
          icon: Layers,
          color: "green",
          title: "Yenilenen Menü Tasarımı",
          description: [
            "Admin menüsü daha ferah ve düzenli bir görünümle güncellendi",
            "Analiz (Raporlar + İstatistikler) ve Ayarlar (Özelleştirme + Sadakat) için açılır menüler eklendi",
            "Açıklamalı dropdown panelleriyle hızlı ve keyifli navigasyon"
          ],
          image: "/menu-redesign.png",
        }
      ],
    },
    {
      version: "1.3.0",
      releaseDate: "8 Şubat 2026",
      features: [
        {
          icon: Calendar,
          color: "cyan",
          title: "Randevular Sayfası Güncellendi",
          description: [
            "Aylık ve haftalık görünüm eklendi",
            "Hız ve performans iyileştirmeleri yapıldı"
          ],
          image: "/appointments-new-feature.png"
        },
        {
          icon: Users,
          color: "blue",
          title: "Müşteri Takip Özelliği",
          description: [
            "Müşteri işlem geçmişi özelliği eklendi",
            "Anasayfada adisyon eklerken takip bilgisi eklenebilir",
            "Müşteriler sayfasında müşteri bilgisine tıklandığında takip bilgileri görüntülenebilir"
          ],
          image: "/customers-new-feature.png"
        },
        {
          icon: Zap,
          color: "green",
          title: "Performans İyileştirmeleri",
          description: [
            "Randevular sayfasında performans iyileştirmeleri yapıldı",
            "Müşteriler sayfasında performans iyileştirmeleri yapıldı"
          ],
        }
      ],
    },
  ];

  const currentVersion = versions[0].version;
  const currentReleaseDate = versions[0].releaseDate;

  const getColorClasses = (color) => {
    const colors = {
      cyan: {
        bg: "bg-cyan-50",
        icon: "text-cyan-500",
        border: "border-cyan-200"
      },
      blue: {
        bg: "bg-blue-50",
        icon: "text-blue-500",
        border: "border-blue-200"
      },
      green: {
        bg: "bg-green-50",
        icon: "text-green-500",
        border: "border-green-200"
      },
      orange: {
        bg: "bg-orange-50",
        icon: "text-orange-500",
        border: "border-orange-200"
      },
      purple: {
        bg: "bg-purple-50",
        icon: "text-purple-500",
        border: "border-purple-200"
      }
    };
    return colors[color];
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/30 backdrop-blur-sm">
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-cyan-500 to-blue-500 p-6 text-white">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-white hover:text-gray-200 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
          
          <div className="flex items-center gap-3 mb-2">
            <Sparkles className="h-8 w-8 animate-pulse" />
            <h2 className="text-3xl font-bold">Yeni Özellikler!</h2>
          </div>
          
          <div className="flex items-center gap-4 text-sm text-cyan-50">
            <span className="font-semibold">Versiyon {currentVersion}</span>
            <span>•</span>
            <span>{currentReleaseDate}</span>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-200px)]">
          <div className="space-y-8">
            {versions.map((versionBlock, vIdx) => (
              <div key={versionBlock.version}>
                {/* Versiyon başlığı */}
                <div className="flex items-center gap-2 mb-4 pb-2 border-b border-gray-200">
                  <span
                    className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                      vIdx === 0
                        ? 'bg-blue-500 text-white'
                        : 'bg-gray-200 text-gray-700'
                    }`}
                  >
                    v{versionBlock.version}
                  </span>
                  <span className="text-sm text-gray-600">{versionBlock.releaseDate}</span>
                  {vIdx === 0 ? (
                    <span className="text-xs font-medium text-blue-700 px-2 py-0.5 bg-blue-50 rounded-full ml-1">
                      ✨ Yeni
                    </span>
                  ) : (
                    <span className="text-xs text-gray-400 ml-1">Önceki sürüm</span>
                  )}
                </div>

                {/* Feature kartları */}
                <div className="space-y-4">
                  {versionBlock.features.map((feature, index) => {
                    const colors = getColorClasses(feature.color);
                    const Icon = feature.icon;

                    return (
                      <div
                        key={index}
                        className={`${colors.bg} ${colors.border} border-2 rounded-xl overflow-hidden transition-all duration-300 hover:shadow-lg`}
                      >
                        {/* Image Section */}
                        {feature.image && (
                          <div className="relative group">
                            <img
                              src={feature.image}
                              alt={feature.title}
                              loading="lazy"
                              className="w-full h-48 object-cover"
                              onError={(e) => {
                                // Dosya henüz yüklenmemişse image block'unu gizle
                                if (e.currentTarget.parentElement) {
                                  e.currentTarget.parentElement.style.display = 'none';
                                }
                              }}
                            />
                            <button
                              onClick={() => setLightboxImage(feature.image)}
                              className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center"
                            >
                              <Maximize2 className="h-8 w-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                            </button>
                          </div>
                        )}

                        {/* Content Section */}
                        <div className="p-4">
                          <div className="flex items-start gap-4">
                            <div className={`${colors.bg} p-3 rounded-lg flex-shrink-0`}>
                              <Icon className={`h-6 w-6 ${colors.icon}`} />
                            </div>
                            <div className="flex-1">
                              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                {feature.title}
                              </h3>
                              <ul className="text-sm text-gray-600 space-y-1">
                                {Array.isArray(feature.description) ? (
                                  feature.description.map((item, idx) => (
                                    <li key={idx} className="flex items-start gap-2">
                                      <span className="text-gray-400 mt-0.5">•</span>
                                      <span>{item}</span>
                                    </li>
                                  ))
                                ) : (
                                  <li className="flex items-start gap-2">
                                    <span className="text-gray-400 mt-0.5">•</span>
                                    <span>{feature.description}</span>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>

          {/* Info Box */}
          <div className="mt-6 bg-gradient-to-r from-cyan-50 to-blue-50 border-l-4 border-blue-500 p-4 rounded-md">
            <p className="text-sm text-gray-700">
              <span className="font-semibold text-blue-700">💡 İpucu:</span> Tüm yeni özellikler hakkında detaylı bilgi için ilgili sayfalara göz atabilirsiniz.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-4 flex flex-col sm:flex-row justify-between items-center gap-3 border-t">
          <label className="flex items-center gap-2 cursor-pointer group">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
              className="w-4 h-4 text-blue-500 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
            />
            <span className="text-sm text-gray-600 group-hover:text-gray-800 transition-colors">
              Bir daha gösterme
            </span>
          </label>
          
          <button
            onClick={() => {
              if (dontShowAgain) {
                onDontShowAgain();
              } else {
                onClose();
              }
            }}
            className="px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-lg hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 font-medium shadow-md hover:shadow-lg"
          >
            Anladım
          </button>
        </div>
      </div>

      {/* Lightbox Modal */}
      {lightboxImage && (
        <div 
          className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={() => setLightboxImage(null)}
        >
          <button
            onClick={() => setLightboxImage(null)}
            className="absolute top-4 right-4 text-white hover:text-gray-300 transition-colors z-10"
          >
            <X className="h-8 w-8" />
          </button>
          <img
            src={lightboxImage}
            alt="Büyütülmüş görünüm"
            className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default ChangelogModal;
